import { cfg } from "../../config";
import dotenv from "dotenv";

dotenv.config();

export async function getAllPuzzleData() {
  try {
    const response = await fetch(
      `${process.env.HOST}/${cfg.API.routes.puzzle}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return { success: false, data: error };
  }
}
